import { Mesh } from 'three';
import { useShallow } from 'zustand/shallow';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';
import { PRIMARY_COLOR_ACCENT_HEX } from 'shared/constants';

export const SnapPointMarker = () => {
    const setSnapPointMarkerRef = usePlacementStore(
        useShallow(state => state.setSnapPointMarkerRef)
    );

    const handleMarkerRef = (marker: Mesh | null) => {
        if (marker) {
            marker.visible = false;
            setSnapPointMarkerRef(marker);
        }
    };

    return (
        <mesh ref={handleMarkerRef}>
            <boxGeometry args={[0.05, 0.05, 0.05]} />
            <meshBasicMaterial color={PRIMARY_COLOR_ACCENT_HEX} opacity={1} transparent />
        </mesh>
    );
};